import { cva } from '@/styled-system/css';

export const calendarYearSelectInputRecipe = cva({
  base: {
    width: `calc({sizes.700} + {spacing.tightest})`,
    opacity: '0',
    border: 'none',
    padding: 0,
    textStyle: 'body-bold',
    color: 'text.neutral',
    appearance: 'none',
    paddingInlineEnd: 'calc({sizes.700} + {spacing.tightest})',
    cursor: 'pointer',
    outline: {
      _focus: 'none',
      _focusVisible: 'none',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {
        '&:focus + button': {
          boxShadow: 'focus',
        },
      },
    },
  },
});
